import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/css/bryntum_styles.css'; // Importa el archivo de estilos de Bryntum
//import 'helpers/initFA';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
